module.exports = __webpack_public_path__ + "static/img/1.c0e25e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/1.png
// module id = iDxO
// module chunks = 0